// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "96f003a532ec65b96d3196b0149346ae574d3a40/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};